import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect, useMemo, useCallback } from "react";
import loadable from "@loadable/component";
import stl from "./PostViewCampaign.module.css";
import { useTranslation } from "@i18n";
import { trackEvents } from "@/common/events/events";
var fallback = {
  fallback: "Loading..."
};
var Countdown = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "react-countdown";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "react-countdown" */"react-countdown");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("react-countdown");
    }
    return eval('require.resolve')("react-countdown");
  }
}, fallback);
var CampaignModal = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-checkout-components-CampaignModal-CampaignModal";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-checkout-components-CampaignModal-CampaignModal" */"@/pages/checkout/components/CampaignModal/CampaignModal");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/checkout/components/CampaignModal/CampaignModal");
    }
    return eval('require.resolve')("@/pages/checkout/components/CampaignModal/CampaignModal");
  }
}, fallback);
var PostViewCampaign = function PostViewCampaign(props) {
  var _activeCampaign$campa2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    showCampaignModal = _useState[0],
    setShowCampaignModal = _useState[1];
  var _useState2 = useState(0),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var bigGallery = false;
  var campaigns = useMemo(function () {
    if (!(props !== null && props !== void 0 && props.newCampaignData)) return [];
    return Array.isArray(props.newCampaignData) ? props.newCampaignData : [props.newCampaignData];
  }, [props === null || props === void 0 ? void 0 : props.newCampaignData]);
  var activeCampaign = campaigns[activeIndex];
  useEffect(function () {
    var _activeCampaign$durat;
    if (campaigns.length <= 1 || showCampaignModal) return;
    var rotationInterval = (_activeCampaign$durat = activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.duration) !== null && _activeCampaign$durat !== void 0 ? _activeCampaign$durat : 8000;
    var interval = setInterval(function () {
      setActiveIndex(function (prev) {
        return (prev + 1) % campaigns.length;
      });
    }, rotationInterval);
    return function () {
      return clearInterval(interval);
    };
  }, [campaigns.length, showCampaignModal, activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.duration]);
  var handleCampaignClick = useCallback(function () {
    var _activeCampaign$campa;
    var hasFinance = (activeCampaign === null || activeCampaign === void 0 ? void 0 : (_activeCampaign$campa = activeCampaign.campaigns) === null || _activeCampaign$campa === void 0 ? void 0 : _activeCampaign$campa.find(function (c) {
      return c.type === "finance";
    })) || (activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.finance);
    trackEvents("marketing_theme_click", _objectSpread(_objectSpread({}, props.g4_data), {}, {
      has_timer: !!(activeCampaign !== null && activeCampaign !== void 0 && activeCampaign.counter_timestamp),
      theme_type: hasFinance ? "Finance" : "Cash"
    }));
  }, [activeCampaign, props.g4_data]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, activeCampaign && !bigGallery && /*#__PURE__*/React.createElement("div", {
    className: stl.newCampaignData,
    style: {
      backgroundColor: activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.bg_color
    },
    onClick: handleCampaignClick
  }, (activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.counter_timestamp) && /*#__PURE__*/React.createElement("div", {
    className: stl.counterCotainer
  }, /*#__PURE__*/React.createElement(Countdown, {
    date: (activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref) {
      var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds,
        days = _ref.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " ", ":", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.campaignText
  }, activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.text), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setShowCampaignModal(true);
    }
  }, t("learn", {
    ns: "web_post_view"
  }))), showCampaignModal && activeCampaign && !bigGallery && /*#__PURE__*/React.createElement(CampaignModal, {
    isPostModal: true,
    dataFromPost: activeCampaign,
    campaignData: campaigns,
    modalName: activeCampaign !== null && activeCampaign !== void 0 && (_activeCampaign$campa2 = activeCampaign.campaigns) !== null && _activeCampaign$campa2 !== void 0 && _activeCampaign$campa2.find(function (c) {
      return c.type === "finance";
    }) || activeCampaign !== null && activeCampaign !== void 0 && activeCampaign.finance ? "finance" : "cash",
    doClose: function doClose() {
      return setShowCampaignModal(null);
    }
  }));
};
export default PostViewCampaign;